export const LOAD_CHARACTERS = 'LOAD_CHARACTERS';
export const LOAD_FAILED = 'LOAD_FAILED';
export const url = 'https://myheroacademiaapi.com/api/character?affiliation=U.A&&page=3';
export const initialState = {
  characters: [],
};
